module.exports = __webpack_public_path__ + "static/media/ramadhancake.03090ac6.jpg";